import { useContext } from 'react';
import { ProfileContext } from '../contexts/ProfileContext';

export default function UseProfile() {
  const profile = useContext(ProfileContext);

  return profile;
}
